export default [{
        path: '/teachers',
        name: 'teachers',
        component: () =>
            import ('@/views/pages/teachers/teachers-list/TeachersList.vue'),
        meta: {
            pageTitle: 'Teachers',
            breadcrumb: [{
                text: 'Teachers',
                active: true,
            }, ],
            resource: 'teacher',
            action: 'read',
        },
    },
    {
        path: '/techers/view/:id',
        name: 'teachers-view',
        component: () =>
            import ('@/views/pages/teachers/teachers-view/TeachersView.vue'),
        meta: {
            pageTitle: 'View Teacher',
            breadcrumb: [
            {
                text: 'Teachers',
                to:'/teachers',
            }, 
            {
                text: 'View',
                active: true,
            }],
            resource: 'teacher',
            action: 'read',
        },
    },
    {
        path: '/teachers/edit/:id',
        name: 'teachers-edit',
        component: () =>
            import ('@/views/pages/teachers/teachers-edit/TeachersEdit.vue'),
        meta: {
            pageTitle: 'Edit Teacher',
            breadcrumb: [
            {
                text: 'Teachers',
                to:'/teachers',
            }, 
            {
                text: 'Edit',
                active: true,
            }],
            resource: 'teacher',
            action: 'read',
        },
    },
    {
        path: '/teachers/add',
        name: 'teachers-add',
        component: () =>
            import ('@/views/pages/teachers/teachers-add/TeachersAdd.vue'),
        meta: {
            pageTitle: 'Add Teacher',
            breadcrumb: [
                {
                    text: 'Teachers',
                    to:'/teachers',
                },
                {
                    text: 'Add',
                    active: true,
                }
            ],
            resource: 'teacher',
            action: 'read',
        }
    }
]